/** Contrato dos feriados — cópia do plano BE-pricing, seção "Feriados" (não importar do BE). */
export type HolidayScope = "national" | "state" | "municipal";
export type HolidayKind = "holiday" | "optional";

export interface Holiday {
  id: number;
  date: string;
  name: string;
  scope: HolidayScope;
  kind: HolidayKind;
  uf: string | null;
  city: string | null;
  source: string;
  seeded: boolean;
  active: boolean;
  createdByName: string | null;
  deactivatedAt: string | null;
  deactivationReason: string | null;
}

export interface HolidaysQuery {
  from?: string;
  to?: string;
  uf?: string;
  city?: string;
  includeInactive?: boolean;
}

/** Só municipais: o escopo vem do BE. */
export interface HolidayInput {
  date: string;
  name: string;
  uf: string;
  city: string;
  kind: HolidayKind;
  source: string;
}

export const BR_UFS = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"] as const;
export const SCOPE_LABEL: Record<HolidayScope, string> = { national: "Nacional", state: "Estadual", municipal: "Municipal" };
export const KIND_LABEL: Record<HolidayKind, string> = { holiday: "Feriado", optional: "Ponto facultativo" };

/** Limites do validador do BE. */
export const LIMITS = { name: [3, 120], city: [2, 120], source: [3, 255], reason: [3, 500] } as const;
